import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Step1 from './Step1';
import Step2 from './Step2';
import { Grid, Step, StepLabel, Stepper } from '@mui/material';
import Step3 from './Step3';
import Step4 from './Step4';
import { useDispatch, useSelector } from 'react-redux';
import { useNotify, Notification } from 'react-admin';
import { showOtpSignUp } from '../../redux/creates-action/OtpAction';
import { verifyPhoneSignUp } from '../../services/SignUp';
import {
  closeLoadingApi,
  openLoadingApi,
} from '../../redux/creates-action/LoadingAction';
import { finalStep } from '../../redux/creates-action/SignUpAction';
import { Link } from 'react-router-dom';
import useResponsive from '../../ultis/helper/useResponsive';

const steps = [
  'Business Registration Certificate',
  'Company information',
  'Bank account',
  'Company representative',
];

function getStepContent(step) {
  switch (step) {
    case 0:
      return <Step1 />;
    case 1:
      return <Step2 />;
    case 2:
      return <Step3 />;
    case 3:
      return <Step4 />;
    default:
      throw new Error('Unknown step');
  }
}

const theme = createTheme();

export default function SignUp() {

  const smUp = useResponsive('up', 'sm');

  const [activeStep, setActiveStep] = React.useState(0);
  const dispatch = useDispatch();
  const notify = useNotify();
  const data1 = useSelector((state) => state.signup.data.businessInfo);
  const data2 = useSelector((state) => state.signup.data.companyInfo);
  const data3 = useSelector((state) => state.signup.data.bankAccount);
  const data4 = useSelector((state) => state.signup.data.companyRep);
  const dataFinal = useSelector((state) => state.signup.data.final);

  React.useEffect(() => {
    if (dataFinal.step === 4) {
      setActiveStep(4);
      notify(dataFinal.message, { type: dataFinal.type });
      dispatch(finalStep('', '', ''));
    } else if (dataFinal.step === 3) {
      setActiveStep(3);
      notify(dataFinal.message, { type: dataFinal.type });
      dispatch(finalStep('', '', ''));
    }
    // eslint-disable-next-line
  }, [dataFinal.step]);

  const handleNext = (e) => {
    e.preventDefault();
    switch (activeStep) {
      case 0:
        if (
          data1.company !== '' &&
          data1.legal !== '' &&
          data1.idType !== '' &&
          data1.registered === false
        ) {
          setActiveStep(activeStep + 1);
        } else if (data1.registered === true) {
          notify('BRC number is registered!', { type: 'error' });
        } else {
          notify('Fields cannot be empty. Please try again.!', {
            type: 'error',
          });
        }
        break;
      case 1:
        if (
          data2.brand !== '' &&
          data2.idCountry !== '' &&
          data2.idState !== '' &&
          data2.idIndustry !== '' &&
          data2.idState !== '' &&
          data2.idCity !== '' &&
          data2.phone !== '' &&
          data2.zipCode !== '' &&
          data2.email !== '' &&
          data2.address !== ''
        ) {
          setActiveStep(activeStep + 1);
        } else {
          notify('Fields cannot be empty. Please try again.!', {
            type: 'error',
          });
        }

        break;
      case 2:
        if (data3.accountId !== '') {
          setActiveStep(activeStep + 1);
        } else {
          notify('Invalid AccountID. Please try again.!', { type: 'error' });
        }
        break;
      case 3:
        if (
          (data4.fullName !== '',
            data4.phone !== '',
            data4.email !== '',
            data4.address !== '')
        ) {
          const data = {
            phone: data4.phone,
          };
          dispatch(openLoadingApi());
          verifyPhoneSignUp(data)
            .then((result) => {
              dispatch(closeLoadingApi());
              if (result !== null) {
                dispatch(showOtpSignUp(data4.phone, 'OTP_SIGNUP'));
              }
            })
            .catch((err) => {
              const response = JSON.parse(JSON.stringify(err));
              const errors = response.response.errors;
              let errorMessage = '';
              errors.map((error) => {
                errorMessage += error.message;
                return error;
              });
              notify(errorMessage, { type: 'error' });
              dispatch(closeLoadingApi());
            });
        } else {
          notify('Fields cannot be empty. Please try again.!', {
            type: 'error',
          });
          dispatch(closeLoadingApi());
        }
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleDone = () => {
    dispatch(finalStep(0, '', ''));
  };

  return (
    <ThemeProvider theme={theme}>
      <Notification />
      <CssBaseline />
      <div>
        <header className="header-section register">
          <div className="overlay">
            <div className="container">
              <div className="row d-flex header-area">
                <nav className="navbar d-flex justify-content-between navbar-expand-lg navbar-dark">
                  <Link
                    className="navbar-brand"
                    to="/"
                    style={{
                      fontWeight: 600,
                      fontSize: '24px',
                      color: '#1a4dbe',
                    }}
                    onClick={handleDone}
                  >
                    <span className="logo-home" />
                    APO
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: '24px',
                        color: '#055c2d',
                      }}
                    >
                      LLO
                    </span>
                  </Link>
                  <div className="d-flex align-items-center justify-content-end">
                    <ul className="navbar-nav">
                      <li className="nav-item">Already have account</li>
                    </ul>
                    <div className="right-area header-action d-flex align-items-center">
                      <Link
                        to="/login"
                        className="cmn-btn"
                        onClick={handleDone}
                      >
                        Login Now
                      </Link>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
        {activeStep === steps.length ? (
          <section className="sign-in-up register">
            <div className="overlay pb-120" style={{ paddingTop: '50px' }}>
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="form-content">
                      <form>
                        <Grid container sx={{ display: 'flex', py: 2 }}>
                          <Grid item xs={12} md={8}>
                            {activeStep === steps.length ? (
                              <></>
                            ) : (
                              <Grid>
                                <Stepper
                                  activeStep={activeStep}
                                  orientation='horizontal'
                                >
                                  {steps.map((label) => (
                                    <Step key={label}>
                                      <StepLabel>{label}</StepLabel>
                                    </Step>
                                  ))}
                                </Stepper>
                              </Grid>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={activeStep === steps.length ? 12 : 9}
                          >
                            <Grid>
                              <React.Fragment>
                                {activeStep === steps.length ? (
                                  <React.Fragment>
                                    <Typography
                                      variant="h3"
                                      align="center"
                                      gutterBottom
                                    >
                                      Your information for sign-up
                                    </Typography>
                                    <Typography
                                      variant="h4"
                                      align="center"
                                      sx={{ mb: 6 }}
                                    >
                                      Merchant onboarding has complete.
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      align="center"
                                      gutterBottom
                                    >
                                      Please wait Admin review and approve
                                    </Typography>
                                    <Button
                                      onClick={handleDone}
                                      href="/"
                                      sx={{
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                      }}
                                      variant="contained"
                                    >
                                      {' '}
                                      Back home page
                                    </Button>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {getStepContent(activeStep)}
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: `${activeStep === 0 ? 'row' : 'column'
                                          }`,
                                        mt: 2,
                                      }}
                                    >
                                      <div
                                        className="btn-area"
                                        style={{ marginBottom: '16px' }}
                                      >
                                        <button
                                          className="cmn-btn"
                                          onClick={handleNext}
                                          style={{ fontSize: '20px' }}
                                        >
                                          {activeStep === steps.length - 1
                                            ? 'Finish'
                                            : 'Next'}
                                        </button>
                                      </div>
                                      <div>
                                        {activeStep !== 0 && (
                                          <div>
                                            <Button
                                              onClick={handleBack}
                                              startIcon={<ArrowBackIcon />}
                                              sx={{
                                                textTransform: 'capitalize',
                                                color: '#000',
                                                textDecoration: 'underline',
                                                fontSize: ' 20px',
                                              }}
                                            >
                                              Back
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </Box>
                                  </React.Fragment>
                                )}
                              </React.Fragment>
                            </Grid>
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section className="sign-in-up register">
            <div className="overlay pb-120" style={{ paddingTop: '10px' }}>
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="form-content">
                      <div className="section-header mb-0">
                        <h5 className="sub-title">
                          The Power of Financial Freedom
                        </h5>
                        <h2 className="title" style={{ marginBottom: '30px' }}>
                          Let’s Get Started!
                        </h2>
                      </div>
                      <form>
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            md={9}
                            sx={{
                              display: 'flex',
                              py: 2,
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {activeStep === steps.length ? (
                              <></>
                            ) : (
                              <Grid
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                {smUp && (
                                  <Stepper
                                    activeStep={activeStep}
                                    orientation='horizontal'
                                  >
                                    {steps.map((label) => (
                                      <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                      </Step>
                                    ))}
                                  </Stepper>
                                )}
                                {!smUp && (
                                  <Stepper
                                    activeStep={activeStep}
                                    orientation='vertical'
                                  >
                                    {steps.map((label) => (
                                      <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                      </Step>
                                    ))}
                                  </Stepper>
                                )}
                              </Grid>
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={activeStep === steps.length ? 12 : 9}
                          >
                            <Grid>
                              <React.Fragment>
                                {activeStep === steps.length ? (
                                  <React.Fragment>
                                    <Typography
                                      variant="h3"
                                      align="center"
                                      gutterBottom
                                    >
                                      Your information for sign-up
                                    </Typography>
                                    <Typography
                                      variant="h4"
                                      align="center"
                                      sx={{ mb: 6 }}
                                    >
                                      Merchant onboarding has complete.
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      align="center"
                                      gutterBottom
                                    >
                                      Please wait Admin review and approve
                                    </Typography>
                                    <Button
                                      href="/"
                                      sx={{
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                      }}
                                      variant="contained"
                                    >
                                      {' '}
                                      Back home page
                                    </Button>
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {getStepContent(activeStep)}
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        mt: 3,
                                        flexDirection: 'column',
                                      }}
                                    >
                                      <div
                                        display={{
                                          display: 'inline-block',
                                          marginBottom: '20px',
                                        }}
                                      >
                                        <div
                                          className="btn-area "
                                          style={{ marginBottom: '16px' }}
                                        >
                                          <button
                                            className="cmn-btn"
                                            onClick={handleNext}
                                            style={{
                                              fontSize: '20px',
                                              textAlign: 'center',
                                            }}
                                          >
                                            {activeStep === steps.length - 1
                                              ? 'Finish'
                                              : 'Next'}
                                          </button>
                                        </div>
                                      </div>
                                      <div>
                                        {activeStep !== 0 && (
                                          <div>
                                            <Button
                                              onClick={handleBack}
                                              startIcon={<ArrowBackIcon />}
                                              sx={{
                                                textTransform: 'capitalize',
                                                color: '#000',
                                                textDecoration: 'underline',
                                                fontSize: ' 20px',
                                              }}
                                            >
                                              Back
                                            </Button>
                                          </div>
                                        )}
                                      </div>
                                    </Box>
                                  </React.Fragment>
                                )}
                              </React.Fragment>
                            </Grid>
                          </Grid>
                        </Grid>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </ThemeProvider>
  );
}
